const IconQuotes = ({className = ''}) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48.18 42.86" className={className}>
    <g>
      <path
        fill="#fff"
        d="M0 42.86v-15.4Q0 14.35 7.08 7.08A25.15 25.15 0 0 1 20.9 0v7.44q-10.62 3-10.63 18.24h6.56v17.18Zm27.45 0v-15.4q0-13.11 7.09-20.38A24.2 24.2 0 0 1 48.18 0v7.44q-10.63 3-10.63 18.24h6.55v17.18Z"
      ></path>
    </g>
  </svg>
);

export default IconQuotes;
